import './SubscriptionModal.scss';

import * as formik from 'formik';
import * as yup from 'yup';

import { Form, Modal } from 'react-bootstrap';
import {
  faCreditCard,
  faQrcode,
} from '@fortawesome/free-solid-svg-icons';

import Alert from 'react-bootstrap/Alert';
import AppButton from '../../commons/buttons/AppButton';
import AppContainer from '../../commons/containers/AppContainer';
import AppInput from '../../commons/inputs/AppInput';
import AppLoading from '../../commons/AppLoading';
import CustomCard from '../../commons/cards/Card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HallAppCenterContainer from '../../commons/containers/HallAppCenterContainer';
import HallAppToast from '../../commons/HallAppToast';
import SignatureAPI from './SignatureAPI';
import bandeirasIMG from '../../assets/images/bandeiras.png';
import forge from 'node-forge';
import { useMask } from '@react-input/mask';
import { useState } from 'react';

const signatureAPI = new SignatureAPI();

const SECRET_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAmvikhXA2Se/mkf8zaOzg+DXHbP4vHc6t0E6nj6wjWV5cWSXBGkWWqhv5PspPUpuAPI3t0ixRaltYE68DfuI2TaUDvpzZitaQHfha0v1sNB3jAWqGf3Tzq01U+Y+9oi3dWcTOVlMak68hLkTXIiU8ySRayyoZgumiPMAxWWlL7c/sfpYnRTjaJz5pd8S3Cl6+uUcXuyZv284UFcLYXQ62RQ9AhfJnhG3FRotAdwNHbZKJMVzJ+RsZUrYsK9ZdzeK5rje1sUSyhghEKMkScefNz/uXJuLsYgl7hes6bESXueSQ6k0n5fu30dmJZJPDyylN9tD1JpsVHEaPWvL3kKPlmQIDAQAB
-----END PUBLIC KEY-----`;

const encryptData = (data) => {
  const rsa = forge.pki.publicKeyFromPem(SECRET_KEY);
  const encrypted = rsa.encrypt(JSON.stringify(data), 'RSA-OAEP');
  return forge.util.encode64(encrypted);
};

const PaymentMethodSelector = ({ value, onChange }) => {
  return (
    <div className="payment-methods">
      <CustomCard
        className={`payment-card ${value === 'CREDIT_CARD' ? 'selected' : ''}`}
        onClick={() => onChange('CREDIT_CARD')}
        role="button"
        tabIndex={0}
        aria-pressed={value === 'CREDIT_CARD'}
      >
        <div className="payment-card__icon">
          <FontAwesomeIcon icon={faCreditCard} size="2x" />
        </div>
        <div className="payment-card__content">
          <h6>Cartão de crédito</h6>
          <span>Pagamento automático recorrente</span>
        </div>
      </CustomCard>

      <CustomCard
        className={`payment-card ${value === 'PIX' ? 'selected' : ''}`}
        onClick={() => onChange('PIX')}
        role="button"
        tabIndex={0}
        aria-pressed={value === 'PIX'}
      >
        <div className="payment-card__icon">
          <FontAwesomeIcon icon={faQrcode} size="2x" />
        </div>
        <div className="payment-card__content">
          <h6>Pix recorrente</h6>
          <span>Gere a chave Pix para cobrança recorrente</span>
        </div>
      </CustomCard>
    </div>
  );
};

const CreditCardForm = ({ plan, call, closeShow }) => {
  const [isLoading, setLoading] = useState(false);
  const { Formik } = formik;

  const [initialValues] = useState({
    number: '',
    name: '',
    dueDate: '',
    cvv: '',
    cpf: '',
  });

  const schema = yup.object().shape({
    number: yup.string().required('Informe o número do cartão'),
    name: yup.string().required('Informe o nome impresso no cartão'),
    dueDate: yup.string().required('Informe a data de vencimento'),
    cvv: yup.string().required('Informe o código CVV'),
    cpf: yup.string().required('Informe o CPF do titular'),
  });

  const dueDateMask = useMask({
    mask: '__/____',
    replacement: { _: /\d/ },
  });

  const create = async (values) => {
    try {
      setLoading(true);

      const encryptedData = encryptData(values);

      const data = {
        creditCardData: encryptedData,
        paymentType: 'CREDIT_CARD',
        planType: 'MONTHLY',
        planId: plan?.id,
      };

      await signatureAPI.subscriptions(data);
      HallAppToast.success();

      if (call) call();
      closeShow();
    } catch (_) {
      HallAppToast.genericError();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="payment-content-box">
      <h6 className="payment-info-title">Informe os dados para pagamento</h6>

      <Alert variant="info" className="payment-alert">
        A renovação será feita automaticamente com base nos dados do cartão informado.
        Você pode cancelar a qualquer momento sem custos.
      </Alert>

      <h4 className="section-title">Cartão de crédito</h4>

      <img
        src={bandeirasIMG}
        alt="Bandeiras aceitas"
        className="card-brands"
      />

      <Formik
        validationSchema={schema}
        onSubmit={create}
        initialValues={initialValues}
        enableReinitialize
      >
        {({ handleSubmit, handleChange, values, touched, errors }) => (
          <Form noValidate onSubmit={handleSubmit} className="payment-form">
            <AppInput
              errors={errors}
              touched={touched}
              name="number"
              onChange={handleChange}
              value={values.number}
              type="text"
              label="Número"
            />

            <AppInput
              errors={errors}
              touched={touched}
              name="name"
              onChange={handleChange}
              value={values.name}
              type="text"
              label="Nome do titular"
            />

            <div className="row">
              <div className="col-md-6">
                <AppInput
                  errors={errors}
                  touched={touched}
                  name="dueDate"
                  onChange={handleChange}
                  value={values.dueDate}
                  mask={dueDateMask}
                  type="text"
                  label="Data de validade"
                />
              </div>

              <div className="col-md-6">
                <AppInput
                  errors={errors}
                  touched={touched}
                  name="cvv"
                  onChange={handleChange}
                  value={values.cvv}
                  type="text"
                  label="CVV"
                />
              </div>
            </div>

            <AppInput
              errors={errors}
              touched={touched}
              name="cpf"
              onChange={handleChange}
              value={values.cpf}
              type="text"
              label="CPF do titular"
            />

            {isLoading ? (
              <HallAppCenterContainer>
                <AppLoading />
              </HallAppCenterContainer>
            ) : (
              <AppButton type="submit" width="100%" name="Atualizar dados" />
            )}
          </Form>
        )}
      </Formik>
    </div>
  );
};

const PixRecurringContent = ({ plan, call, closeShow }) => {
  const [isLoading, setLoading] = useState(false);
  const { Formik } = formik;

  const [initialValues] = useState({
    name: '',
    cpfOrCnpj: '',
  });

  const schema = yup.object().shape({
    name: yup.string().required('Informe o nome completo'),
    cpfOrCnpj: yup.string().required('Informe o CPF ou CNPJ'),
  });

  const generatePixKey = async (values) => {
    try {
      setLoading(true);

      const data = {
        paymentType: 'PIX',
        planType: 'MONTHLY',
        planId: plan?.id,
        name: values.name,
        cpfOrCnpj: values.cpfOrCnpj,
      };

      await signatureAPI.subscriptions(data);
      HallAppToast.success();

      if (call) call();
      closeShow();
    } catch (_) {
      HallAppToast.genericError();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="payment-content-box">
      <h6 className="payment-info-title">Pix recorrente</h6>

      <Alert variant="info" className="payment-alert">
        Ao escolher o Pix recorrente, a cobrança da assinatura será gerada de forma
        recorrente via Pix. Preencha os dados abaixo e gere a chave para continuar.
      </Alert>

      <div className="pix-content">
        <div className="pix-content__icon">
          <FontAwesomeIcon icon={faQrcode} size="3x" />
        </div>

        <h4>Gerar chave Pix</h4>
        <p>
          Informe os dados abaixo para ativar o plano <strong>{plan?.name}</strong>{' '}
          com cobrança recorrente.
        </p>
      </div>

      <Formik
        validationSchema={schema}
        onSubmit={generatePixKey}
        initialValues={initialValues}
        enableReinitialize
      >
        {({ handleSubmit, handleChange, values, touched, errors }) => (
          <Form noValidate onSubmit={handleSubmit} className="payment-form">
            <AppInput
              errors={errors}
              touched={touched}
              name="name"
              onChange={handleChange}
              value={values.name}
              type="text"
              label="Nome completo"
            />

            <AppInput
              errors={errors}
              touched={touched}
              name="cpfOrCnpj"
              onChange={handleChange}
              value={values.cpfOrCnpj}
              type="text"
              label="CPF ou CNPJ"
            />

            {isLoading ? (
              <HallAppCenterContainer>
                <AppLoading />
              </HallAppCenterContainer>
            ) : (
              <AppButton
                type="submit"
                width="100%"
                name="Gerar chave Pix"
              />
            )}
          </Form>
        )}
      </Formik>
    </div>
  );
};

function SubscriptionModal({ closeShow, show, call, plan }) {
  const [paymentSelected, setPaymentSelected] = useState('CREDIT_CARD');

  return (
    <Modal
      show={show}
      fullscreen
      onHide={closeShow}
      dialogClassName="subscription-modal-dialog"
    >
      <Modal.Header closeButton>
        <Modal.Title>Pagamento</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <AppContainer>
          <h5 className="selected-plan">
            Plano selecionado: <strong>{plan?.name}</strong>
          </h5>

          <hr />

          <h4 className="payment-title">Forma de pagamento</h4>

          <PaymentMethodSelector
            value={paymentSelected}
            onChange={setPaymentSelected}
          />

          <div className="payment-component-wrapper">
            {paymentSelected === 'CREDIT_CARD' && (
              <CreditCardForm
                plan={plan}
                call={call}
                closeShow={closeShow}
              />
            )}

           {paymentSelected === 'PIX' && (
              <PixRecurringContent
                plan={plan}
                call={call}
                closeShow={closeShow}
              />
            )} 
          </div>
        </AppContainer>
      </Modal.Body>
    </Modal>
  );
}

export default SubscriptionModal;